import {useCallback} from "react";
import {getSubmit, postSubmit} from "@ui-seeker/utils";

import {BACKEND_APIS} from "@constants";
import {isLoadMoreItems, productsMatcherItems, productsMatcherGroupBy, productsMatcherBatchGroupBy} from "../@signals";


export default function useProductsMatcherItems() {

	const handleSubmit = useCallback((id_mapping = null) => {
		isLoadMoreItems.value = true
		const params = {}
		if (id_mapping) params.id_mapping = id_mapping
		getSubmit(`${BACKEND_APIS.MATCHERS}/products/load-items`, params).then(({ items, batchGroupBy }) => {
			productsMatcherItems.value = [...(productsMatcherItems.value || []), ...items]
			if (batchGroupBy) {
				productsMatcherBatchGroupBy.value = batchGroupBy
				productsMatcherGroupBy.value = batchGroupBy
			}
			isLoadMoreItems.value = false
		}).catch(() => isLoadMoreItems.value = false)
	}, [])

	const handleMoreProducts = useCallback(() => {
		productsMatcherItems.value = null
		postSubmit(`${BACKEND_APIS.MATCHERS}/skus/disabled-filters`).then(() => {
			handleSubmit()
		}).catch(() => productsMatcherItems.value = [])
	}, [])


	return {
		handleSubmit,
		handleMoreProducts
	}
}